module.exports = __webpack_public_path__ + "static/scale-model-of-museum-of-glass-in-tacoma-washington-0857b204a4b9414cca8912c2fd82dc64.png";